import { FC } from "react";

import CalenderIcon from "@icons/calender.svg";
import LocationIcon from "@icons/location-icon.svg";

import CustomButtom from "./CustomButtom";
import { StyledGrid } from "./styles";

interface DateLocationButtonType {
  handleChangeDateClick: () => void;
  formatteddate: string;
  handleChangeLocationClick: () => void;
  property: string;
  isDesktop: boolean;
}

const DateLocationButton: FC<DateLocationButtonType> = ({
  handleChangeDateClick,
  formatteddate,
  handleChangeLocationClick,
  property,
  isDesktop,
}) => {
  return (
    <StyledGrid>
      <CustomButtom
        value={formatteddate}
        handleButtonClick={handleChangeDateClick}
        icon={CalenderIcon}
        label="Date"
        isDesktop={isDesktop}
      />
      <CustomButtom
        value={property}
        handleButtonClick={handleChangeLocationClick}
        icon={LocationIcon}
        label="home"
        isDesktop={isDesktop}
      />
    </StyledGrid>
  );
};

export default DateLocationButton;
